"use client"

import { ChakraProvider, defaultSystem, SystemContext } from '@chakra-ui/react';
import {
  ColorModeProvider,
  type ColorModeProviderProps,
} from "./color-mode"

interface ProviderProps extends ColorModeProviderProps {
  system?: SystemContext
}

export function Provider(props: ProviderProps) {
  const { system, ...colorModeProps } = props
  return (
    <ChakraProvider value={system || defaultSystem}>
      <ColorModeProvider {...colorModeProps} />
    </ChakraProvider>
  )
}
